import type {
  DemoResetStepId,
  DemoResetWorkflowEvent,
  DemoResetWorkflowOutputs,
} from "../_shared/_logic/demo-data-reset-contract"

export const applyDemoResetWorkflowEvent = (
  outputs: DemoResetWorkflowOutputs,
  event: DemoResetWorkflowEvent,
): DemoResetWorkflowOutputs => {
  if (event.type === "member_selected" && event.role === "primary") {
    return { primary: event.output }
  }

  if (event.type === "member_selected") {
    return { primary: outputs.primary, secondary: event.output }
  }

  if (event.type === "member_edit_requested" && event.role === "primary") {
    return {}
  }

  if (event.type === "member_edit_requested") {
    return { primary: outputs.primary }
  }

  return {
    primary: outputs.primary,
    secondary: outputs.secondary,
    reset: { result: event.result, downloadedFiles: ["admin", "employee"] },
  }
}

export const completedDemoResetSteps = (outputs: DemoResetWorkflowOutputs): DemoResetStepId[] => [
  ...(outputs.primary ? (["primary"] as const) : []),
  ...(outputs.secondary ? (["secondary"] as const) : []),
  ...(outputs.reset ? (["reset"] as const) : []),
]
